<template>
  <div id="app" class="app">
    <a class="skip-link" href="#main-content">Skip to main content</a>

    <!-- Decorative background -->
    <div class="bg-grid" aria-hidden="true"></div>
    <div class="bg-glow bg-glow--a" aria-hidden="true"></div>
    <div class="bg-glow bg-glow--b" aria-hidden="true"></div>

    <Header />

    <main id="main-content" class="page">
      <Projects />
      <About />
      <Experience />
      <Skills />
    </main>

    <Footer />
  </div>
</template>

<script>
import About from "./components/About.vue";
import Experience from "./components/Experience.vue";
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
import Projects from "./components/Projects.vue";
import Skills from "./components/Skills.vue";

export default {
  name: "App",
  components: {
    About,
    Experience,
    Footer,
    Header,
    Projects,
    Skills,
  },
};
</script>

<style>
/* Kept for backwards compatibility (older components used .card) */
.card {
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
}
</style>
